import { useMutation } from "react-query";
import usePopup from "../../hooks/usePopup";
import { ResponseType } from "../../Types/ServicesType/servicesType";
import { PatientFullDetailsType } from "../PatientBooking/v1/types";
import { getConstants } from "@utilifiles/methods/storage/storage";
import api from "@services/apiList";
import instance from "@services/services";
const { clinicId } = getConstants()
const { patientRegistrationApi, patientEncounterApi } = api;

export type PatientSearchData = {
  id: number;
  status: number;
  isVip: number;
  foDate: string;
  gender: string;
  age: number;
  dob: string;
  middleName: string | null;
  lastName: string;
  firstName: string;
  mobileNo: string;
  patientId: string;
  emiratesId: string;
};

type ParamsType = {
  encounterId?: number | null;
  emrNo?: string;
  bookingId?: number | null;
  emiratesId?: string | null;
  gccId?: string | null;
  passNum?: string | null;
};
export const useFetchPatientDetailsByEMR = ({
  onSuccess,
}: {
  onSuccess?: (data: ResponseType<PatientFullDetailsType>) => void;
}) => {
  const { showSnackbar } = usePopup();
  return useMutation(
    async (
      params: ParamsType
    ): Promise<ResponseType<PatientFullDetailsType>> => {
      if (Boolean(params.emiratesId || params.gccId || params.passNum)) {
        return (
          await instance.post(`${patientRegistrationApi.getPatientById}`, {
            clinicId,
            ...params,
          })
        ).data;
      } else {
        return (
          await instance.post(
            `${patientRegistrationApi.getPatientByemr}`,
            params.encounterId
              ? { clinicId, ...params, encounterId: params.encounterId }
              : { clinicId, ...params, encounterId: params.encounterId || null }
          )
        ).data;
      }
    },
    {
      onSuccess: (data) => {
        if (onSuccess) {
          onSuccess(data);
        }
      },
      onError: (e: any) => {
        showSnackbar({
          message:
            e?.response?.data?.responseMessage || "Something went wrong !",
          open: true,
          variant: "warning",
          duration: 3000,
        });
      },
    }
  );
};

export const usePatientSearch = () => {
  return useMutation(
    async ({
      searchText,
    }: {
      searchText: string;
    }): Promise<ResponseType<PatientSearchData[]>> => {
      return (
        await instance.post(`${patientEncounterApi.getAllPatient}`, {
          emrNo: searchText,
          clinicId: clinicId,
        })
      ).data;
    }
  );
};
